import { connect } from 'react-redux';

import Header from '../components/Header';

const mapStateToProps = ({ userConfig: { showCrumbTrail } }) => ({
  showCrumbTrail,
});

export default connect(mapStateToProps)(Header);
